import styles from './MeasurmentTime.module.scss';

interface Time {
  hh: string;
  mm: string;
}

interface TimeSelectProps {
  time: Time;
  setTime: React.Dispatch<React.SetStateAction<Time>>;
}

const TimeSelect = ({ time, setTime }: TimeSelectProps) => {
  return (
    <div className={styles.timeSelect}>
      <select
        value={time.hh}
        onChange={(e) => setTime((prev) => ({ ...prev, hh: e.target.value }))}
      >
        {<option value="--">--</option>}
        {Array.from({ length: 24 }, (_, i) => (
          <option key={i} value={String(i).padStart(2, '0')}>
            {String(i).padStart(2, '0')}
          </option>
        ))}
      </select>
      <span>:</span>
      <select
        value={time.mm}
        onChange={(e) => setTime((prev) => ({ ...prev, mm: e.target.value }))}
      >
        {<option value="--">--</option>}
        {Array.from({ length: 60 }, (_, i) => (
          <option key={i} value={String(i).padStart(2, '0')}>
            {String(i).padStart(2, '0')}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TimeSelect;
